import { Account } from '@modules-deprecated/app/accounts/types'

export const getAccountFromBookkeepingTagAnswer = (
  accountId: string | number,
  accounts?: Account[],
): Account | undefined => {
  return accountId ? accounts?.find((account) => account.id === accountId) : undefined
}
